import request from '../../axios';

interface IResponse {
  report_file: string;
}

export const postFarmValidationFile = async (loanGuid: string, file: File) => {
  const formData = new FormData();

  formData.append('report_file', file);

  const {data}: {data: IResponse} = await request.post(
    `/api/v2/payment/farm-validation-file/loan-request/${loanGuid}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data;
};
